export const FINANCE_NAVIGATION_TABS = {
  FISCAL_YEAR: 'fiscalyear',
  LEDGER: 'ledger',
  GROUPS: 'groups',
  FUND: 'fund',
};
